module.exports = __webpack_public_path__ + "static/media/Noshin.dde12879.jpg";